import { UseFormSetError } from 'react-hook-form';
import authService from '../components/api-authorization/AuthorizeService'
import CreateMembershipCommand from "../models/membership/CreateMembershipCommand"
import {MembershipViewModel} from "../models/membership/MembershipViewModel"
import MembershipSummaryViewModel from "../models/membership/MembershipSummaryViewModel"

export default class MembershipController {
  
    async CreateMembership(event: CreateMembershipCommand, setError: UseFormSetError<any>) : Promise<MembershipViewModel|undefined> {
        const token = await authService.getAccessToken();
        const response = await fetch('membership/CreateMembership', {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}`, 'Content-Type': `application/json` },
            method: 'POST',
            body: JSON.stringify(event)
        });
        if (response.status == 201) {
            return response.json();
        }
        var body = await response.json();
        if(response.status == 400 && body.errors)
        {
            var errors = body.errors
            Object.keys(errors).forEach((key) => {
                setError(key, { type: "server", message: errors[key] })
            })
        }
        if(response.status == 400 && body)
        {
            var errors = body
            Object.keys(errors).forEach((key) => {
                setError(key, { type: "server", message: errors[key] })
            })
        }
        return;
    }

    async EditMembership(event: CreateMembershipCommand, setError: UseFormSetError<any>)  : Promise<MembershipViewModel|undefined> {
        const token = await authService.getAccessToken();
        const response = await fetch('membership/EditMembership', {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}`, 'Content-Type': `application/json` },
            method: 'POST',
            body: JSON.stringify(event)
        });
        if (response.status == 201) {
            return response.json();
        }
        var body = await response.json();
        if(response.status == 400 && body.errors)
        {
            var errors = body.errors
            Object.keys(errors).forEach((key) => {
                setError(key, { type: "server", message: errors[key] })
            })
        }
        if(response.status == 400 && body)
        {
            var errors = body
            Object.keys(errors).forEach((key) => {
                setError(key, { type: "server", message: errors[key] })
            })
        }
        return;
    }

    async GetMembership(id: string): Promise<MembershipViewModel | null> {
        const token = await authService.getAccessToken();
        const response = await fetch('membership/GetMembership?Id=' + id, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}`, 'Content-Type': `application/json` },
            method: 'GET'
        });
        if (response.status == 200) {
            const data = await response.json();
            return data;
        }
        return null;
    }

    async GetMembershipSummary(): Promise<MembershipSummaryViewModel | null> {
        const token = await authService.getAccessToken();
        const response = await fetch('membership/GetMembershipSummary', {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}`, 'Content-Type': `application/json` },
            method: 'GET'
        });
        if (response.status == 200) {
            const data = await response.json();
            return data;
        }
        return null;
    }
}
